<template>
  <transition-group name="fade" tag="picture" :class="['img', css, imgClasses]">
    <source
      v-for="(source) in sources"
      ref="source"
      :key="source['media']"
      :media="source['media']"
      :data-srcset="source['srcset']">
      <img
        ref="image"
        class="img__el"
        :src="sizeSrc"
        :alt="alt"
        :key="src"
        @load="onLoaded" />
    <i
      v-if="loader"
      class="img__loader spinner"
      :key="0"></i>
  </transition-group>
</template>
<script>
import objectFitImages from 'object-fit-images'

export default {
  props: {
    src: String,
    sources: Array,
    alt: String,
    css: String,
    size: Number,
    loader: {
      type: Boolean,
      default: false
    },
    spinner: {
      type: Boolean,
      default: true
    },
    spinnerSize: {
      type: String,
      default: 'lg'
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      mainImageSrc: '',
      secondaryImgSrc: '',
      states: {
        isLoaded: false
      }
    }
  },
  computed: {
    imgClasses () {
      return this.states.isLoaded ? 'is-loaded' : ''
    },
    parts () {
      const arr = this.src.split(new RegExp(`.(jpg|jpeg|png|gif)`))

      return {
        originalPath: arr[0],
        filePath: arr[0].replace(new RegExp(`_[0-9]*x`), ''),
        ext: arr[1],
        query: arr[2]
      }
    },
    blurSrc () {
      return this.getSizeSrc(50)
    },
    blurSrcStyle () {
      return `url(${this.blurSrc})`
    },
    sizeSrc () {
      return this.size ? this.getSizeSrc(this.size) : this.src
    },
    spinnerActive () {
      return !this.states.isLoaded
    },
    spinnerClass () {
      return `spinner spinner--abs z1 spinner--${this.spinnerSize}`
    }
  },
  mounted () {
    if (this.loader) {
      this.loadImage(this.blurSrc)
    }

    if (typeof this.$refs['source'] !== 'undefined' && this.$refs['source'].length > 0) {
      this.getSrcset(this.$refs['source'])
    }
  },
  methods: {
    onLoaded () {
      this.states.isLoaded = true
      const { image } = this.$refs
      const { scale } = this

      if (!image) {
        return
      }

      image.setAttribute('width', image.width * scale)
      image.setAttribute('height', image.height * scale)
    },
    getSizeSrc (size) {
      const { filePath, ext, query } = this.parts
      return `${filePath}_${size}x.${ext + query}`
    },
    loadImage (src, onLoad) {
      const img = new Image()

      img.onload = onLoad
      img.src = src
      objectFitImages()
    },
    getSrcset (sources) {
      for (const source of sources) {
        if (source.hasAttribute('data-srcset')) {
          source.setAttribute('srcset', source.getAttribute('data-srcset'))
          source.removeAttribute('data-srcset')
        }
      }
    }
  },
  template: `
    
  `
}
</script>

<style lang="scss">
  .img,
  .img__el {
    bottom: 0;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }

  .img {
    overflow: hidden;

    &.fit-cover {
      .img__el {
        object-fit: cover;
        /* stylelint-disable */
        font-family: 'object-fit: cover;';
        /* stylelint-enable */
      }
    }

    &.fit-contain {
      .img__el {
        object-fit: contain;
        /* stylelint-disable */
        font-family: 'object-fit: contain;';
        /* stylelint-enable */
      }
    }

    &.is-loaded {
      .img__el {
        opacity: 1;
        visibility: visible;
      }

      .img__loader {
        opacity: 0;
        visibility: hidden;
      }
    }

    &.is-transparent {
      background-color: transparent;
    }
  }

  .img__el {
    opacity: 0;
    transition-duration: 0.3s;
    transition-property: opacity, visibility, z-index;
    transition-timing-function: ease;
    visibility: hidden;
    z-index: 2;

    &.is-fallback {
      opacity: 1;
      visibility: visible;
    }

    /* For Vue transitions */
    &.fade-enter,
    &.fade-leave-to {
      opacity: 0 !important;
    }

    &.fade-enter {
      z-index: 1;
    }
  }

  .img__loader {

  }
</style>